import { useContext } from 'react';
// import ReactPaginate from 'react-paginate';

import PageContext from '@contexts/PageContext';
import { Container } from '@components';
import { checkEnabled } from '@components/OptionalFeature';
import { ArticlePreview } from '@containers';
import styles from './Children.module.scss';

const Children = ({ data, componentIsAvailable, showTitle, componentTitle }) => {
  const pageData = useContext(PageContext);

  const FeaturedChildrenEnabled = pageData?.DisplayOptions?.find((item) => item.Name == 'Featured Children')?.DisplayOptions?.find(
    (x) => x.DisplayOptionKey == 'DisplayComponent'
  ).Enabled;
  const FeatureChildrenCount = pageData?.DisplayOptions?.find((item) => item.Name == 'Featured Children')?.DisplayOptions?.find(
    (x) => x.DisplayOptionKey == 'Count'
  ).OptionInformation;
  const FeatureChildrenLinkOutEnabled = checkEnabled(pageData?.DisplayOptions?.find((item) => item.Name == 'Featured Children')?.DisplayOptions, 'LinkOut');

  // show buttonText
  const showButtonText = checkEnabled(data?.DisplayOptions, 'ButtonText');

  // show shortDescription
  const shortDescriptionEnabled = checkEnabled(data?.DisplayOptions, 'Short Description');

  // show subject
  const subjectEnabled = checkEnabled(data?.DisplayOptions, 'Subject');

  // Children content
  const childrenData = pageData?.Children?.map((child) => child.p);

  // show image
  const imageEnabled = checkEnabled(data?.DisplayOptions, 'BackgroundHero');

  const linkOutEnabled = checkEnabled(data?.DisplayOptions, 'LinkOut');

  return (
    componentIsAvailable && (
      <section className={styles.Section}>
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{componentTitle}</h2>}
          <div className={styles.List}>
            {FeaturedChildrenEnabled
              ? childrenData
                  .splice(FeatureChildrenCount)
                  .map((post) => (
                    <ArticlePreview
                      key={post.Id}
                      data={post}
                      showButtonText={showButtonText}
                      shortDescriptionEnabled={shortDescriptionEnabled}
                      subjectEnabled={subjectEnabled}
                      LinkOutEnabled={linkOutEnabled || FeatureChildrenLinkOutEnabled}
                      imageEnabled={imageEnabled}
                    />
                  ))
              : childrenData.map((post) => (
                  <ArticlePreview
                    key={post.Id}
                    data={post}
                    showButtonText={showButtonText}
                    shortDescriptionEnabled={shortDescriptionEnabled}
                    subjectEnabled={subjectEnabled}
                    LinkOutEnabled={linkOutEnabled}
                    imageEnabled={imageEnabled}
                  />
                ))}
          </div>
          {/* <ReactPaginate
              previousLabel={'< Previous'}
              nextLabel={'Next >'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={5}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              //onPageChange={updatePageination}
              containerClassName={styles.pagination}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              //forcePage={pagination.page}
            /> */}
        </Container>
      </section>
    )
  );
};

export default Children;
